export const OPERATOR = {
  name: "Jens Wirringa",
  business: "WattNu Ostfriesland – Online-Portal für Veranstaltungen und Ausflugsziele",
  street: "Innersteweg 1",
  city: "30419 Hannover",
  email: "jens.wirringa@gmail.com",
  phone: "+49 176 80014858",
  vatId: null,
  authority: "Die Landesbeauftragte für den Datenschutz Niedersachsen, Prinzenstraße 5, 30159 Hannover",
  updated: "November 2026",
};

export const isPlaceholder = (v) => typeof v === "string" && v.startsWith("[");
